<template>
  <div class="documents-panel">
    <div class="filter-toggle-bar">
      <button class="filter-toggle-btn" type="button" @click="showFilters = !showFilters">
        <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M22 3H2l8 9.46V19l4 2v-8.54L22 3z"/></svg>
        Filtros
        <span v-if="activeFilterCount > 0" class="filter-active-badge">{{ activeFilterCount }}</span>
        <svg class="filter-chevron" :class="{ rotated: showFilters }" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="6 9 12 15 18 9"/></svg>
      </button>
      <button v-if="activeFilterCount > 0" class="filter-clear-btn" type="button" @click="clearFilters">Limpar filtros</button>
    </div>
    <Transition name="filter-bar">
    <div v-show="showFilters" class="filter-bar">
      <div class="filter-group">
        <label class="filter-label" for="reportTypeFilter">Tipo</label>
        <select id="reportTypeFilter" class="filter-select" :value="filterType" @change="$emit('set-filter-type', ($event.target as HTMLSelectElement).value)">
          <option value="">Todos os tipos</option>
          <option v-for="item in allTypes" :key="item" :value="item">{{ item }}</option>
        </select>
      </div>
      <div class="filter-group">
        <label class="filter-label" for="reportUserFilter">Autor</label>
        <select id="reportUserFilter" class="filter-select" :value="userFilter" @change="$emit('set-user-filter', ($event.target as HTMLSelectElement).value)">
          <option value="">Todos os autores</option>
          <option v-for="item in userOptions" :key="item" :value="item">{{ item }}</option>
        </select>
      </div>
      <div class="filter-group">
        <label class="filter-label" for="reportDateFrom">De</label>
        <input id="reportDateFrom" class="filter-input" :value="dateFrom" type="date" @input="$emit('set-date-from', ($event.target as HTMLInputElement).value)" />
      </div>
      <div class="filter-group">
        <label class="filter-label" for="reportDateTo">Até</label>
        <input id="reportDateTo" class="filter-input" :value="dateTo" type="date" @input="$emit('set-date-to', ($event.target as HTMLInputElement).value)" />
      </div>
    </div>
    </Transition>

    <Transition name="sel-bar">
      <div v-if="selectedItems.length > 0" class="selection-bar">
        <span class="sel-count">{{ selectedItems.length }} selecionado{{ selectedItems.length > 1 ? 's' : '' }}</span>
        <div class="sel-actions">
          <button class="export-btn export-btn--doc" type="button" @click="openLang('doc')">
            <svg width="14" height="14" viewBox="0 0 15 15" fill="none"><rect x="2" y="1" width="11" height="13" rx="1.5" stroke="currentColor" stroke-width="1.3"/><path d="M5 5h5M5 7.5h5M5 10h3" stroke="currentColor" stroke-width="1.3" stroke-linecap="round"/></svg>
            Word
          </button>
          <button class="export-btn export-btn--pdf" type="button" @click="openLang('pdf')">
            <svg width="14" height="14" viewBox="0 0 15 15" fill="none"><path d="M3 1.5h6l3 3V13a.5.5 0 01-.5.5H3A.5.5 0 012.5 13V2A.5.5 0 013 1.5z" stroke="currentColor" stroke-width="1.3"/><path d="M9 1.5V4.5h3M5 7h1.5c.828 0 1.5.448 1.5 1s-.672 1-1.5 1H5V10" stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            PDF
          </button>
          <button class="export-btn export-btn--delete" type="button" @click="$emit('delete-docs')">
            <svg width="13" height="13" viewBox="0 0 14 14" fill="none"><path d="M2 3.5h10M5.5 3.5V2.5h3V3.5M4.5 3.5v7.5h5V3.5" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round"/></svg>
            Apagar
          </button>
        </div>
      </div>
    </Transition>

    <SkeletonList v-if="showSkeleton" variant="row" :count="5" :columns="[3, 40, 15, 10, 15]" />

    <div v-else-if="filteredItems.length === 0" class="empty-state">
      <svg width="44" height="44" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><polyline points="14 2 14 8 20 8"/><line x1="16" y1="13" x2="8" y2="13"/><line x1="16" y1="17" x2="8" y2="17"/><polyline points="10 9 9 9 8 9"/></svg>
      <p class="empty-title">Nenhum relatório encontrado</p>
      <p class="empty-sub">Tente ajustar os filtros acima.</p>
      <button class="empty-btn" type="button" @click="$emit('toggle-create')">Criar relatório</button>
    </div>

    <div v-else class="doc-list">
      <div class="doc-list-header">
        <div class="col-check"></div>
        <div class="col-title">Relatório</div>
        <div class="col-project">Projeto</div>
        <div class="col-date">Data</div>
        <div class="col-author">Autor</div>
        <div class="col-actions"></div>
      </div>

      <div
        v-for="item in filteredItems"
        :key="item.id"
        class="doc-row"
        :class="{ selected: selectedItems.includes(item.id) }"
      >
        <div class="col-check">
          <input class="doc-checkbox" type="checkbox" :checked="selectedItems.includes(item.id)" @change="$emit('toggle-item', item.id)" />
        </div>
        <div class="col-title">
          <span class="type-badge" :data-type="item.title">{{ item.title || 'Relatório' }}</span>
          <div class="doc-title-wrap">
            <button class="doc-title doc-title-link" type="button" @click="$emit('view', item.id)">{{ item.title }}</button>
            <span v-if="activitiesText(item)" class="doc-preview">{{ activitiesText(item) }}</span>
          </div>
        </div>
        <div class="col-project">{{ item.attraction }}</div>
        <div class="col-date">{{ formatReportDate(item.reportDate) }}</div>
        <div class="col-author">
          <div class="author-avatar" :title="item.author.name">{{ item.author.name?.charAt(0)?.toUpperCase() }}</div>
          <span class="author-name">{{ item.author.name }}</span>
        </div>
        <div class="col-actions">
          <button class="row-link" type="button" @click="$emit('view', item.id)">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><path d="m21 21-4.35-4.35"/></svg>
            Ver
          </button>
          <button class="row-link" type="button" @click="$emit('edit', item.id)">
            <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"/><path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"/></svg>
            Editar
          </button>
        </div>
      </div>
    </div>

    <Teleport to="body">
      <div v-if="showLangModal" class="lang-overlay" @click.self="showLangModal = false">
        <div class="lang-modal">
          <div class="lang-modal-header">
            <h3 class="lang-modal-title">
              {{ exportTarget === 'doc' ? 'Gerar documento Word (.docx)' : 'Gerar PDF' }}
            </h3>
            <p class="lang-modal-sub">Selecione o idioma do documento gerado</p>
          </div>
          <div class="lang-grid">
            <button v-for="loc in LANGUAGES" :key="loc.code" class="lang-option" type="button" @click="selectLang(loc.code)">
              <span class="lang-flag">{{ loc.flag }}</span>
              <span class="lang-label">{{ loc.label }}</span>
            </button>
          </div>
          <div class="lang-modal-footer">
            <button class="lang-cancel" type="button" @click="showLangModal = false">Cancelar</button>
          </div>
        </div>
      </div>
    </Teleport>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, computed, type PropType } from 'vue'
import { submissionsStore, type Submission } from '@/store/submissions'
import SkeletonList from '@/components/skeleton/SkeletonList.vue'

const LANGUAGES = [
  { code: 'pt', label: 'Português', flag: 'PT' },
  { code: 'en', label: 'English', flag: 'EN' },
  { code: 'es', label: 'Español', flag: 'ES' },
  { code: 'de', label: 'Deutsch', flag: 'DE' },
  { code: 'fr', label: 'Français', flag: 'FR' },
  { code: 'it', label: 'Italiano', flag: 'IT' },
  { code: 'zh', label: '中文', flag: 'ZH' },
  { code: 'ja', label: '日本語', flag: 'JA' },
  { code: 'ko', label: '한국어', flag: 'KO' },
  { code: 'ru', label: 'Русский', flag: 'RU' },
  { code: 'nl', label: 'Nederlands', flag: 'NL' }
]

export default defineComponent({
  name: 'ReportsPanel',
  components: { SkeletonList },
  props: {
    allTypes: { type: Array as PropType<string[]>, default: () => [] },
    filterType: { type: String, default: '' },
    userFilter: { type: String, default: '' },
    dateFrom: { type: String, default: '' },
    dateTo: { type: String, default: '' },
    userOptions: { type: Array as PropType<string[]>, default: () => [] },
    selectedItems: { type: Array as PropType<string[]>, default: () => [] },
    filteredItems: { type: Array as PropType<Submission[]>, default: () => [] },
    formatReportDate: { type: Function as PropType<(v: string) => string>, required: true },
    activitiesText: { type: Function as PropType<(item: Submission) => string>, required: true }
  },
  emits: ['set-filter-type', 'set-user-filter', 'set-date-from', 'set-date-to', 'export-docs', 'export-pdfs', 'delete-docs', 'toggle-item', 'view', 'edit', 'toggle-create'],
  setup(props, { emit }) {
    const showFilters = ref(false)
    const activeFilterCount = computed(() =>
      (props.filterType ? 1 : 0) + (props.userFilter ? 1 : 0) + (props.dateFrom ? 1 : 0) + (props.dateTo ? 1 : 0)
    )
    const clearFilters = () => {
      emit('set-filter-type', '')
      emit('set-user-filter', '')
      emit('set-date-from', '')
      emit('set-date-to', '')
    }

    const showSkeleton = computed(() => submissionsStore.state.loading && props.filteredItems.length === 0)

    const showLangModal = ref(false)
    const exportTarget = ref<'doc' | 'pdf'>('doc')

    const openLang = (target: 'doc' | 'pdf') => {
      exportTarget.value = target
      showLangModal.value = true
    }

    const selectLang = (lang: string) => {
      showLangModal.value = false
      if (exportTarget.value === 'doc') emit('export-docs', lang)
      else emit('export-pdfs', lang)
    }

    return { showFilters, activeFilterCount, clearFilters, showLangModal, exportTarget, openLang, selectLang, LANGUAGES, showSkeleton }
  }
})
</script>

<style scoped lang="scss">
.filter-toggle-bar {
  display: flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 8px;
}

.filter-toggle-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
  background: var(--card, #fff);
  border: 1px solid rgba(31, 30, 26, 0.12);
  border-radius: 7px;
  padding: 7px 14px;
  font-size: 13px;
  font-weight: 600;
  color: var(--ink, #2c2b27);
  cursor: pointer;
  transition: background 0.12s;

  &:hover { background: rgba(31, 30, 26, 0.04); }
}

.filter-active-badge {
  background: var(--system-navbar, #0f4c81);
  color: #fff;
  border-radius: 10px;
  padding: 1px 7px;
  font-size: 11px;
  font-weight: 700;
}

.filter-chevron {
  transition: transform 0.18s;
  color: var(--ink-muted, #888);

  &.rotated { transform: rotate(180deg); }
}

.filter-clear-btn {
  background: none;
  border: none;
  color: var(--ink-muted, #888);
  font-size: 12px;
  cursor: pointer;
  padding: 4px 8px;

  &:hover { color: var(--ink, #2c2b27); text-decoration: underline; }
}

.filter-bar-enter-active,
.filter-bar-leave-active {
  transition: opacity 0.18s, transform 0.18s;
  overflow: hidden;
}

.filter-bar-enter-from,
.filter-bar-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.filter-bar {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  align-items: flex-end;
  background: var(--card, #fff);
  border: 1px solid rgba(31, 30, 26, 0.1);
  border-radius: 12px;
  padding: 14px 16px;
  margin-bottom: 16px;
}

.filter-group {
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 140px;
  flex: 1;
}

.filter-label {
  font-size: 11px;
  font-weight: 600;
  color: var(--ink-muted, #888);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}

.filter-select,
.filter-input {
  padding: 7px 10px;
  border-radius: 7px;
  border: 1.5px solid rgba(31, 30, 26, 0.15);
  font-size: 13px;
  color: var(--ink, #2c2b27);
  background: #fff;
  outline: none;
  transition: border-color 0.14s;

  &:focus {
    border-color: var(--system-navbar, #0f4c81);
  }
}

.selection-bar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  flex-wrap: wrap;
  background: var(--system-navbar, #0f4c81);
  color: #fff;
  border-radius: 10px;
  padding: 10px 16px;
  margin-bottom: 12px;
}

.sel-count {
  font-size: 13px;
  font-weight: 600;
  opacity: 0.9;
}

.sel-actions {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

.sel-bar-enter-active,
.sel-bar-leave-active {
  transition: all 0.2s ease;
}

.sel-bar-enter-from,
.sel-bar-leave-to {
  opacity: 0;
  transform: translateY(-6px);
}

.export-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 13px;
  border-radius: 7px;
  border: 1.5px solid transparent;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.14s, background 0.14s;
  white-space: nowrap;

  &--doc {
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    border-color: rgba(255, 255, 255, 0.3);
  }

  &--pdf {
    background: rgba(255, 255, 255, 0.08);
    color: #fff;
    border-color: rgba(255, 255, 255, 0.2);
  }

  &--delete {
    background: rgba(239, 68, 68, 0.15);
    color: #fecaca;
    border-color: rgba(239, 68, 68, 0.35);
  }
}

.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 10px;
  padding: 80px 20px;
  text-align: center;
  color: var(--ink-muted, #aaa);

  svg {
    opacity: 0.3;
  }
}

.empty-title {
  margin: 0;
  font-size: 16px;
  font-weight: 700;
  color: var(--ink, #2c2b27);
}

.empty-sub {
  margin: 0;
  font-size: 13px;
}

.empty-btn {
  border: none;
  border-radius: 999px;
  background: var(--system-navbar, #0f4c81);
  color: #fff;
  padding: 10px 16px;
  font-size: 13px;
  font-weight: 700;
  cursor: pointer;
}

.doc-list {
  width: 100%;
}

.doc-list-header {
  display: grid;
  grid-template-columns: 32px 3fr 1.4fr 100px 1.2fr 120px;
  column-gap: 14px;
  padding: 8px 12px;
  font-size: 11px;
  font-weight: 700;
  color: var(--ink-muted, #888);
  text-transform: uppercase;
  letter-spacing: 0.05em;
  border-bottom: 1.5px solid rgba(31, 30, 26, 0.1);
  margin-bottom: 2px;
}

.doc-row {
  display: grid;
  grid-template-columns: 32px 3fr 1.4fr 100px 1.2fr 120px;
  column-gap: 14px;
  align-items: center;
  padding: 10px 12px;
  border-radius: 8px;
  border-bottom: 1px solid rgba(31, 30, 26, 0.06);
  transition: background 0.1s;

  &:hover {
    background: rgba(31, 30, 26, 0.025);
  }

  &.selected {
    background: rgba(37, 99, 235, 0.05);
    border-color: rgba(37, 99, 235, 0.12);
  }
}

.col-check {
  display: flex;
  align-items: center;
  justify-content: center;
}

.doc-checkbox {
  width: 15px;
  height: 15px;
  accent-color: var(--system-navbar, #0f4c81);
  cursor: pointer;
}

.col-title {
  display: flex;
  align-items: center;
  gap: 10px;
  min-width: 0;
}

.type-badge {
  flex-shrink: 0;
  font-size: 10px;
  font-weight: 700;
  padding: 2px 7px;
  border-radius: 4px;
  background: #e0f2fe;
  color: #0369a1;
  white-space: nowrap;
  text-transform: uppercase;
  letter-spacing: 0.04em;

  &[data-type='Relatorio diario de obra'],
  &[data-type='RDO'] {
    background: #dcfce7;
    color: #15803d;
  }

  &[data-type='Relatorio de incidente'],
  &[data-type='RDS'] {
    background: #fef3c7;
    color: #92400e;
  }
}

.doc-title-wrap {
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.doc-title {
  font-size: 13px;
  font-weight: 500;
  color: var(--ink, #2c2b27);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.doc-title-link {
  background: none;
  border: none;
  padding: 0;
  cursor: pointer;
  text-align: left;
  &:hover { color: var(--system-navbar, #0f4c81); text-decoration: underline; }
}

.doc-preview {
  font-size: 11px;
  color: var(--ink-muted, #aaa);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col-project,
.col-date {
  font-size: 12px;
  color: var(--ink-muted, #888);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col-author {
  display: flex;
  align-items: center;
  gap: 7px;
  min-width: 0;
}

.author-avatar {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  flex-shrink: 0;
  background: var(--system-navbar, #0f4c81);
  color: #fff;
  font-size: 11px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.author-name {
  font-size: 12px;
  color: var(--ink-muted, #888);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.col-actions {
  display: flex;
  gap: 4px;
  justify-content: flex-end;
}

.row-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  background: transparent;
  border: none;
  cursor: pointer;
  font-size: 12px;
  font-weight: 500;
  color: var(--ink-muted, #666);
  padding: 5px 9px;
  border-radius: 6px;
  transition: background 0.1s, color 0.1s;

  &:hover {
    background: rgba(31, 30, 26, 0.06);
    color: var(--ink, #2c2b27);
  }
}

.lang-overlay {
  position: fixed;
  inset: 0;
  z-index: 1000;
  background: rgba(0, 0, 0, 0.45);
  display: grid;
  place-items: center;
  padding: 20px;
}

.lang-modal {
  width: min(560px, 100%);
  background: #fff;
  border-radius: 18px;
  padding: 22px;
  box-shadow: 0 22px 60px rgba(15, 23, 42, 0.25);
}

.lang-modal-header {
  margin-bottom: 14px;
}

.lang-modal-title {
  margin: 0 0 4px;
  font-size: 20px;
  color: var(--ink, #2c2b27);
}

.lang-modal-sub {
  margin: 0;
  color: var(--ink-muted, #666);
  font-size: 13px;
}

.lang-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(120px, 1fr));
  gap: 10px;
}

.lang-option {
  border: 1px solid rgba(31, 30, 26, 0.12);
  background: #fff;
  border-radius: 12px;
  padding: 12px;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 5px;
  cursor: pointer;
}

.lang-flag {
  font-size: 12px;
  font-weight: 800;
  color: var(--system-navbar, #0f4c81);
}

.lang-label {
  font-size: 14px;
  font-weight: 600;
}

.lang-modal-footer {
  display: flex;
  justify-content: flex-end;
  margin-top: 14px;
}

.lang-cancel {
  border: none;
  background: transparent;
  color: var(--ink-muted, #666);
  cursor: pointer;
  font-weight: 600;
}

@media (max-width: 860px) {
  .doc-list-header {
    display: none;
  }

  .doc-row {
    grid-template-columns: 24px 1fr;
    gap: 10px;
    align-items: start;
  }

  .col-title {
    grid-column: 2;
  }

  .col-project,
  .col-date,
  .col-author,
  .col-actions {
    grid-column: 2;
    justify-content: flex-start;
  }
}
</style>
